import React, { useEffect, useState } from "react";
import "./Login_signup.css";
import { Form, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import PasswordChecklist from "react-password-checklist";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
// import Success_Modal from '../success_modal/Success_Modal';
import { useLocation, useNavigate } from "react-router-dom";
import Light_Black_Btn from "../../common_btn/light_black_btn/Light_Black_Btn";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { AllCountry } from "../../../../features/admin/common/Slice";
import { CreateSignup } from "../../../../features/admin/auth/Slice";

import { Link } from "react-router-dom";

const Signup_Modal = ({
  setSelectedModal,
  setShowSucsessModal,
  setSuccessText,
  ...props
}) => {
  const {
    control, reset,
    register, setError,
    handleSubmit, getValues,
    formState: { errors },
  } = useForm();

  const [selectLogin, setSelectLogin] = useState(false);

  console.log("selectLogin", selectLogin);

  const navigate = useNavigate();
  const dispatch = useDispatch()

  const [showSignUp, setShowSignUp] = useState(false);

  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
  const [showSetPassModal, setShowSetPassModal] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);

  // const countries = [
  //   { value: "chocolate", label: "Chocolate" },
  //   { value: "strawberry", label: "Strawberry" },
  //   { value: "vanilla", label: "Vanilla" },
  // ];

  const countries = useSelector((state) => state.common.all_country);

  useEffect(() => {
    dispatch(AllCountry());
  }, [dispatch]);

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  const SignUP = async (data) => {

    console.log("FORM DATA:", data);
    const sendData = new FormData();
    sendData.append("name", data.name || "");
    sendData.append("email", data.email || "");
    sendData.append("contact_no", data.contact_no || "");
    sendData.append("password", data.password || "");
    sendData.append("country_id", data.country_id?.value || "");
    sendData.append("concent_given", data.consent_given || false);
    sendData.append("guidelines_accepted", data.guidelines_accepted || false);



    const res = await dispatch(CreateSignup(sendData));

    // console.log({ CreateSignup: res });


    if (res.meta?.requestStatus === "fulfilled") {
      reset()
      setShowSucsessModal(true);
      setSuccessText("Sign Up Succesfully !");
      setTimeout(() => {
        setShowSucsessModal(false);
        navigate(0);
      }, 3000);
      props?.onHide();
      navigate("/home")

    } else if (res.meta?.requestStatus === "rejected") {
      if (res.payload?.errors?.email) {
        setError("email", {
          type: "manual",
          message: res.payload?.errors?.email,
        });
      }
      if (res.payload?.errors?.contact_no) {
        setError("contact_no", {
          type: "manual",
          message: res.payload?.errors?.contact_no,
        });
      }

    }

  };

  const location = useLocation();

  useEffect(() => {
    if (location.state) {
      reset(location.state);
    }
  }, [location.state]);


  return (
    <>
      <div className="signup_div">
        <div className="login_form_div">
          <Form>
            <div className="row">
              <div className="col-md-12">
                <Form.Group className="gray_input_group input_group">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Full Name"
                    {...register("name", {
                      required: "Full name is required",
                      minLength: {
                        value: 3,
                        message: "Name must be at least 3 characters",
                      },
                      maxLength: {
                        value: 50,
                        message: "Name cannot exceed 50 characters",
                      },
                      pattern: {
                        value: /^[A-Za-z\s]+$/,
                        message: "Name can only contain letters and spaces",
                      },
                    })}
                  />

                  {errors.name && (
                    <p style={{ fontSize: "13px", color: "red" }}>
                      {errors.name.message}
                    </p>
                  )}
                </Form.Group>
              </div>
            </div>

            <div className="row mt-2">
              <div className="col-sm-6">
                <Form.Group className="gray_input_group input_group">
                  <Form.Label>Contact</Form.Label>
                  <Form.Control
                    placeholder="Contact Number"
                    type="text"
                    name="contact_no"
                    maxLength={10} // restrict typing to 10 digits
                    {...register("contact_no", {
                      required: "Contact Number is required",
                      pattern: {
                        value: /^[0-9]+$/,  // only numbers
                        message: "Only digits are allowed",
                      },
                      minLength: {
                        value: 10,
                        message: "Contact Number must be exactly 10 digits",
                      },
                      maxLength: {
                        value: 10,
                        message: "Contact Number must be exactly 10 digits",
                      },
                    })}
                  />
                  {errors.contact_no && (
                    <p style={{ fontSize: "13px", color: "red" }}>
                      {errors.contact_no.message}
                    </p>
                  )}
                </Form.Group>

              </div>

              <div className="col-sm-6">
                <Form.Group className="gray_input_group input_group">
                  <Form.Label>Country of Residence</Form.Label>
                  <Controller
                    className="Select_Dropdown_holder"
                    name="country_id"
                    control={control}
                    rules={{ required: "Country is required" }}
                    render={({ field }) => (
                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors.country_id ? "red" : baseStyles,
                          }),
                        }}
                        {...field}
                        options={countries}
                      />
                    )}
                  />
                  {errors.country_id && (
                    <p style={{ fontSize: "13px", color: "red" }}>
                      {errors.country_id.message}
                    </p>
                  )}
                </Form.Group>
              </div>
            </div>

            <Form.Group className="gray_input_group input_group">
              <Form.Label>Email ID</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your email"
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Enter a valid email address",
                  },
                })}
              />

              {errors.email && (
                <p style={{ fontSize: "13px", color: "red" }}>
                  {errors.email.message}
                </p>
              )}
            </Form.Group>

            <Form.Group className="gray_input_group input_group">
              <Form.Label className="label_text">Password</Form.Label>
              <div className="password_holder">
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Enter Password"
                  {...register("password", {
                    required: "Password is required",
                    minLength: {
                      value: 8,
                      message: "Password must be at least 8 characters long",
                    },
                    pattern: {
                      value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                      message:
                        "Password must contain at least one uppercase letter, one lowercase letter, and one number",
                    },
                  })}
                  onChange={(e) => setPassword(e.target.value)}
                />
                {errors.password && (
                  <p style={{ fontSize: "13px", color: "red" }}>
                    {errors.password.message}
                  </p>
                )}
                <div className="eye-icc">
                  <FontAwesomeIcon
                    icon={iconOne}
                    className="icon"
                    onClick={() => togglePasswordVisibility("password")}
                  />
                </div>
              </div>
            </Form.Group>

            <Form.Group className="gray_input_group input_group">
              <Form.Label className="label_text">Confirm Password</Form.Label>
              <div className="password_holder">
                <Form.Control
                  placeholder="Confirm Password"
                  type={showPasswordOne ? "text" : "password"}
                  name="re_password"
                  {...register("re_password", {
                    required: "Re-Enter Password  is required",
                  })}
                  onChange={(e) => setPasswordAgain(e.target.value)}
                />

                <div className="eye-icc">
                  <FontAwesomeIcon
                    icon={iconTwo}
                    className="icon"
                    onClick={() => togglePasswordVisibility("reenterPassword")}
                  />
                </div>


                {errors.re_password && (
                  <p style={{ fontSize: "13px", color: "red" }}>
                    {errors.re_password.message}
                  </p>
                )}
              </div>
            </Form.Group>

            {password && (
              <div className="password_check_list">
                <PasswordChecklist
                  rules={[
                    "minLength",
                    "specialChar",
                    "number",
                    "capital",
                    "match",
                  ]}
                  minLength={8}
                  value={password}
                  valueAgain={passwordAgain}
                  onChange={(isValid) => { }}
                  style={{
                    fontSize: "10px",
                    padding: "4px",
                    margin: "0",
                  }}
                />
              </div>
            )}
          </Form>

          {/* <div className="eye-icc">
            <FontAwesomeIcon
              icon={iconTwo}
              className="icon"
              onClick={() => {
                props?.onHide();
                navigate("/concent");
              }}
            />
          </div> */}


          {/* CONSENT CHECKBOX (MANDATORY) */}
          <Form.Check
            className="p_checkBoxx"
            type="checkbox"
            {...register("consent_given", {
              required: "You must provide consent before continuing",
            })}
            label={
              <>
                I agree to the collection and processing of my personal data as per the{" "}
                <span
                  className="link-btn text-primary"
                  style={{ cursor: "pointer", textDecoration: "underline" }}
                  onClick={() => {
                    props?.onHide(); // close modal first
                    navigate("/consent", {
                      state: getValues(),
                    });
                  }}
                >
                  Omtapovan   <Link to={"/settings/privacy-policy"}> Privacy Policy</Link>
                </span>.
              </>
            }
          />

          {errors.consent_given && (
            <p className="text-danger small">{errors.consent_given.message}</p>
          )}


          <Form.Check
            className="p_checkBoxx"
            type="checkbox"
            {...register("guidelines_accepted", {
              required: "You must accept the guidelines to continue",
            })}
            label={
              <>
                I agree to follow the{" "}
                <span
                  className="link-btn text-primary"
                  style={{ cursor: "pointer", textDecoration: "underline" }}
                  onClick={() => {
                    props?.onHide();
                    navigate("/consent", {
                      state: getValues(),
                    });
                  }}
                >
                  Omtapovan Spiritual & Community Guidelines
                </span>{" "}
                during the program.
              </>
            }
          />

          {errors.guidelines_accepted && (
            <p className="text-danger small">
              {errors.guidelines_accepted.message}
            </p>
          )}

        </div>

        <div className="btn_holder">
          <Light_Black_Btn
            btnText="Sign Up"
            onClick={handleSubmit(SignUP)}
          // onClick={() => {
          //   setSuccessText("Sign Up Succesfully !");
          //   setShowSucsessModal(true);
          //   setTimeout(() => {
          //     setShowSucsessModal(false);
          //   }, 3000);
          //   props?.onHide();
          // }}
          />
        </div>

        <p className="dark_text">
          Already have an account?{" "}
          <span
            className="link_text"
            onClick={() => {
              setSelectedModal("select_login");
            }}
          >
            Log In
          </span>
          .
        </p>
      </div>
    </>
  );
};

export default Signup_Modal;
